export default "__VITE_PUBLIC_ASSET__95e63a5e__"